import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=ffde90b6&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "../sass/custom.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Layout.vue?vue&type=style&index=1&id=ffde90b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffde90b6",
  null
  
)

export default component.exports